import React, {Fragment} from "react";
import PropTypes from "prop-types";

import {ADDRESSES_TYPES} from "./constants";


const PrintDocumentInfoFabricator = (props) => {
  const {styles, fabricatorData, threeColumns, messages} = props;

  const {View, Text} = window.ReactPdfRenderer;

  const mainAddress = Array.isArray(fabricatorData.addresses) && fabricatorData.addresses.find(adr => {
    return adr.addressType === ADDRESSES_TYPES.Shipping
  })

  const city = mainAddress && mainAddress.city ? mainAddress.city : fabricatorData.city || "";
  const address = mainAddress && mainAddress.address1 ? mainAddress.address1 : fabricatorData.address1 || fabricatorData.address2 || "";
  const postal = mainAddress && mainAddress.postal ? mainAddress.postal : fabricatorData.postal || "";
  const provence = mainAddress && mainAddress.provence ? mainAddress.provence : fabricatorData.provence || "";
  let displayAddress = "";
  [city, provence, postal].forEach(addressPart => { // 1) city 2) provence 3) postal
    if (addressPart) {
      if (displayAddress) {
        displayAddress += ", "
      }
      displayAddress += addressPart
    }
  });
  const contactEmail = fabricatorData.contactEmail || "";
  const emails = contactEmail.includes(",") ? contactEmail.split(",") : [];

  return (
    <View style={threeColumns ? [styles.section, styles.sectionRight] : [styles.sectionTwo, styles.sectionRight]}>
      <Text style={styles.mainTitle}>{messages["receipt.mainInfo.fabricatorInformation"]}</Text>
      <Text style={styles.mainText}>{fabricatorData.companyName}</Text>
      {address ? <Text style={styles.mainText}>{address}</Text> : null}
      {displayAddress ? <Text style={styles.mainText}>{displayAddress}</Text> : null}
      {fabricatorData.isCaesarStone ? null : (
        <Fragment>
          {emails ? emails.map((email, emailIndex) => {
            return (
              <Text key={emailIndex} style={emailIndex ? styles.mainText : [styles.mainText, styles.mainTextEmail]}>
                {email}
              </Text>
            )
          }) : <Text style={[styles.mainText, styles.mainTextEmail]}>{contactEmail}</Text>}
          <Text style={styles.mainText}>{fabricatorData.phone || ""}</Text>
        </Fragment>
      )}
    </View>
  )
};

PrintDocumentInfoFabricator.propTypes = {
  fabricatorData: PropTypes.object.isRequired,
  threeColumns: PropTypes.bool,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentInfoFabricator
